module.exports = __webpack_public_path__ + "src/assets/img/exercise-details.a3b2642f.png";